import React from 'react';
import { FaGithub } from 'react-icons/fa';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const lastUpdated = 'December 18th, 2025'

  return (
    <div className="bg-[#123458] text-[#F1EFEC] text-xs sm:text-sm py-4 sm:py-6 px-4 mt-8 sm:mt-12 lg:-mt-[24px] z-10">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">

        {/* github + contact me */}
        <div className="flex gap-4 sm:gap-6 items-center">
          <a href="https://github.com/ofinucan7" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 hover:underline hover:text-[#D4C9BE] transition-colors"> 
            <FaGithub className="text-sm sm:text-base" /> 
            <span className="text-xs sm:text-sm">GitHub</span>
          </a>
        </div>

        {/* back to top */}
        <button onClick={ scrollToTop } className="hover:underline cursor-pointer transition-colors hover:text-[#D4C9BE] text-xs sm:text-sm order-last sm:order-none"> 
          ↑ Back to top 
        </button>

        {/* last updated */}
        <div className="text-[#D4C9BE] text-xs sm:text-sm">
          Last updated: { lastUpdated }
        </div>
      </div>
    </div>
  );
};